import { Link } from "react-router-dom";
import { Scale, XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="text-center max-w-md" data-testid="payment-cancel">
        <Scale className="w-8 h-8 text-primary mx-auto mb-8" />
        <XCircle className="w-12 h-12 text-muted-foreground mx-auto mb-6" />
        <h1 className="font-serif text-4xl mb-2">Checkout canceled</h1>
        <p className="text-muted-foreground mb-6">No charge was made. You can subscribe whenever you're ready.</p>
        <Link to="/subscribe" className="inline-block bg-primary text-primary-foreground px-6 py-3 rounded-sm text-sm hover:-translate-y-[1px] transition-transform">
          Back to membership
        </Link>
      </div>
    </div>
  );
}
